import type { TranslationTag } from '@ps/web-core-intl';

import {
  TXTWCL_Alt_Passing_TDs,
  TXTWCL_Alt_Passing_Yds,
  TXTWCL_Alt_Receiving_Yds,
  TXTWCL_Alt_Rushing_Yds,
  TXTWCL_Alternate_Handicap,
  TXTWCL_Away_Team_First_Half_Over_Unde_ELL,
  TXTWCL_Away_Team_Over_Under,
  TXTWCL_Away_Team_Second_Half_Over_Und_ELL,
  TXTWCL_Away_Team_Total_Cards_in_a_Gam_ELL,
  TXTWCL_Away_Team_Total_Corners,
  TXTWCL_Both_Teams_to_Score_Markets,
  TXTWCL_Corners_Race,
  TXTWCL_First_Half_Over_Under_Goals,
  TXTWCL_Game_Lines,
  TXTWCL_Goalkeeper_Saves_Markets,
  TXTWCL_Goalscorers,
  TXTWCL_Home_Team_First_Half_Over_Unde_ELL,
  TXTWCL_Home_Team_Over_Under,
  TXTWCL_Home_Team_Second_Half_Over_Und_ELL,
  TXTWCL_Home_Team_Total_Cards_in_a_Gam_ELL,
  TXTWCL_Home_Team_Total_Corners,
  TXTWCL_Over_Under_Goals,
  TXTWCL_Player_Assists,
  TXTWCL_Player_Assists_XOver_UnderX,
  TXTWCL_Player_Blocks,
  TXTWCL_Player_Made_Threes,
  TXTWCL_Player_Made_Threes_XOver_Under_ELL,
  TXTWCL_Player_Passing_TDs,
  TXTWCL_Player_Passing_Yds,
  TXTWCL_Player_Points,
  TXTWCL_Player_Points_XOver_UnderX,
  TXTWCL_Player_Rebounds,
  TXTWCL_Player_Rebounds_XOver_UnderX,
  TXTWCL_Player_Receiving_Yds,
  TXTWCL_Player_Rushing_Yds,
  TXTWCL_Player_Shots_1_3,
  TXTWCL_Player_Shots_On_Target,
  TXTWCL_Player_Steals_1,
  TXTWCL_Player_Threes,
  TXTWCL_Player_To_Commit_A_Foul,
  TXTWCL_Player_To_Win_A_Foul,
  TXTWCL_Player_Total_Receptions,
  TXTWCL_Second_Half_Over_Under_Goals,
  TXTWCL_Set_1_Total_Games,
  TXTWCL_Set_2_Total_Games,
  TXTWCL_TD_Scorer,
  TXTWCL_Team_Total_Shots,
  TXTWCL_Team_Total_Shots_On_Target,
  TXTWCL_Total_Cards,
  TXTWCL_Total_Corners
} from './marketTemplateTranslationMap.messages.json';

export const marketTemplateTranslationMap: Partial<Record<string, TranslationTag>> = {
  ALTERNATE_HANDICAP: TXTWCL_Alternate_Handicap,
  ISP_I18N_AWAY_TEAM_FIRST_HALF_OVER_UNDER: TXTWCL_Away_Team_First_Half_Over_Unde_ELL,
  ISP_I18N_AWAY_TEAM_OVER_UNDER: TXTWCL_Away_Team_Over_Under,
  ISP_I18N_AWAY_TEAM_SECOND_HALF_OVER_UNDER: TXTWCL_Away_Team_Second_Half_Over_Und_ELL,
  ISP_I18N_AWAY_TEAM_TOTAL_CARDS_IN_A_GAME: TXTWCL_Away_Team_Total_Cards_in_a_Gam_ELL,
  ISP_I18N_AWAY_TEAM_TOTAL_CORNERS: TXTWCL_Away_Team_Total_Corners,
  ISP_I18N_BOTH_TEAMS_TO_SCORE_MARKETS: TXTWCL_Both_Teams_to_Score_Markets,
  ISP_I18N_CORNERS_RACE: TXTWCL_Corners_Race,
  ISP_I18N_FIRST_HALF_OVER_UNDER_GOALS: TXTWCL_First_Half_Over_Under_Goals,
  ISP_I18N_GAME_LINES: TXTWCL_Game_Lines,
  ISP_I18N_GOALKEEPER_SAVES: TXTWCL_Goalkeeper_Saves_Markets,
  ISP_I18N_GOALSCORERS: TXTWCL_Goalscorers,
  ISP_I18N_HOME_TEAM_FIRST_HALF_OVER_UNDER: TXTWCL_Home_Team_First_Half_Over_Unde_ELL,
  ISP_I18N_HOME_TEAM_OVER_UNDER: TXTWCL_Home_Team_Over_Under,
  ISP_I18N_HOME_TEAM_SECOND_HALF_OVER_UNDER: TXTWCL_Home_Team_Second_Half_Over_Und_ELL,
  ISP_I18N_HOME_TEAM_TOTAL_CARDS_IN_A_GAME: TXTWCL_Home_Team_Total_Cards_in_a_Gam_ELL,
  ISP_I18N_HOME_TEAM_TOTAL_CORNERS: TXTWCL_Home_Team_Total_Corners,
  ISP_I18N_OVER_UNDER_GOALS: TXTWCL_Over_Under_Goals,
  ISP_I18N_PLAYER_ALT_PASSING_TDS: TXTWCL_Alt_Passing_TDs,
  ISP_I18N_PLAYER_ALT_PASSING_YDS: TXTWCL_Alt_Passing_Yds,
  ISP_I18N_PLAYER_ALT_RECEIVING_YDS: TXTWCL_Alt_Receiving_Yds,
  ISP_I18N_PLAYER_ALT_RUSHING_YDS: TXTWCL_Alt_Rushing_Yds,
  ISP_I18N_PLAYER_MADE_THREES: TXTWCL_Player_Made_Threes,
  ISP_I18N_PLAYER_PASSING_TDS: TXTWCL_Player_Passing_TDs,
  ISP_I18N_PLAYER_PASSING_YDS: TXTWCL_Player_Passing_Yds,
  ISP_I18N_PLAYER_RECEIVING_YDS: TXTWCL_Player_Receiving_Yds,
  ISP_I18N_PLAYER_RUSHING_YDS: TXTWCL_Player_Rushing_Yds,
  ISP_I18N_PLAYER_SHOTS_ON_TARGET: TXTWCL_Player_Shots_On_Target,
  ISP_I18N_PLAYER_SHOTS: TXTWCL_Player_Shots_1_3,
  ISP_I18N_PLAYER_TO_COMMIT_FOUL: TXTWCL_Player_To_Commit_A_Foul,
  ISP_I18N_PLAYER_TO_WIN_FOUL: TXTWCL_Player_To_Win_A_Foul,
  ISP_I18N_PLAYER_TOTAL_RECEPTIONS: TXTWCL_Player_Total_Receptions,
  ISP_I18N_SECOND_HALF_OVER_UNDER_GOALS: TXTWCL_Second_Half_Over_Under_Goals,
  ISP_I18N_SET_1_TOTAL_GAMES: TXTWCL_Set_1_Total_Games,
  ISP_I18N_SET_2_TOTAL_GAMES: TXTWCL_Set_2_Total_Games,
  ISP_I18N_TEAM_TOTAL_SHOTS_ON_TARGET: TXTWCL_Team_Total_Shots_On_Target,
  ISP_I18N_TEAM_TOTAL_SHOTS: TXTWCL_Team_Total_Shots,
  ISP_I18N_TOTAL_CARDS: TXTWCL_Total_Cards,
  ISP_I18N_TOTAL_CORNERS: TXTWCL_Total_Corners,
  ISP_I18N_TOUCHDOWN_SCORERS: TXTWCL_TD_Scorer,
  ISP_I18N_PLAYER_ASSISTS: TXTWCL_Player_Assists,
  ISP_I18N_PLAYER_ASSISTS_OVER_UNDER: TXTWCL_Player_Assists_XOver_UnderX,
  ISP_I18N_PLAYER_BLOCKS: TXTWCL_Player_Blocks,
  ISP_I18N_PLAYER_THREES: TXTWCL_Player_Threes,
  ISP_I18N_PLAYER_MADE_THREES_OVER_UNDER: TXTWCL_Player_Made_Threes_XOver_Under_ELL,
  ISP_I18N_PLAYER_POINTS: TXTWCL_Player_Points,
  ISP_I18N_PLAYER_POINTS_OVER_UNDER: TXTWCL_Player_Points_XOver_UnderX,
  ISP_I18N_PLAYER_REBOUNDS: TXTWCL_Player_Rebounds,
  ISP_I18N_PLAYER_REBOUNDS_OVER_UNDER: TXTWCL_Player_Rebounds_XOver_UnderX,
  ISP_I18N_PLAYER_STEALS: TXTWCL_Player_Steals_1
};
